<template>
  <modal-component :back="back">
    <div class="modal-container2">
      <div class="left">
        <div class="white-card" style="min-height: 300px">
          <div class="loader absolute" v-if="loading"></div>
          <template v-else-if="currentVideo">
            <h4 class="fw-300">
              {{ currentVideo.title }}
            </h4>

            <div class="row mb-3">
              <div class="col-sm-8">
                <hr class="mt-0 mb-1">
                <video-player :key="currentVideo.id" :video="currentVideo" @play="play"/>
              </div>
              <div class="col-sm-4">
                <div class="description">
                  <h5 class="text-green fw-700">Description</h5>
                  <p class="fw-300">{{ currentVideo.description }}</p>
                </div>
              </div>
            </div>

            <carousel v-if="videos.length>1" class="conference-slider" :navigation-enabled="true"
                      :space-padding="0" :per-page="3"
                      :pagination-enabled="false" :navigation-click-target-size="0"
                      :scroll-per-page="false">
              <slide class="course-slide" v-for="(video,i) in videos" :key="i">
                <div class="video-thumb cursor-pointer" :class="{ activeVid: index === i }">
                  <img
                    @click="evt=> index=i"
                    class="z-depth-1 w-100"
                    :src="video.thumb">
                  <span>{{ `${i + 1}. ${video.title}` }}</span>
                </div>
              </slide>
            </carousel>
          </template>
        </div>
        <training-component :has_quiz="has_quiz" :slug="slug" :has_exercises="has_exercises"
                            v-if="has_exercises||has_quiz"
                            class="mt-5"/>
      </div>
      <div class="right" v-if="discussion_id">
        <chat-widget :discussion-id="discussion_id" class="fixed"/>
      </div>
    </div>
  </modal-component>
</template>

<script>
import ModalComponent from "../../components/LayoutPartials/ModalComponent";
import axios from "axios";
import TrainingComponent from "@/components/Lesson/TrainingComponent";
import ChatWidget from "@/components/Chat/ChatWidget";
import VideoPlayer from "@/components/VideoPlayer";

export default {
  components: {ChatWidget, TrainingComponent, ModalComponent, VideoPlayer},
  props: ["fileName"],
  data() {
    return {
      index: 0,
      videos: [],
      title: null,
      back: null,
      slug: null,
      has_exercises: false,
      has_quiz: false,
      loading: true,
      discussion_id: null
    };
  },
  computed: {
    currentVideo() {
      return this.videos[this.index]
    },
    lessonId() {
      return this.$slugId(this.$route.params.slug)
    }
  },
  methods: {
    play() {
      axios.post(`/action/lesson/${this.lessonId}/video/${this.currentVideo.id}`)
    }
  },
  mounted() {
    this.loading = true
    axios.get(`/lesson/${this.lessonId}/videos`)
      .then(({data}) => {
        this.videos = data.videos
        this.title = data.title
        this.back = {name: 'lesson', params: {slug: data.slug}}
        this.slug = data.slug
        this.has_quiz = data.has_quiz
        this.has_exercises = data.has_exercises
        this.discussion_id = data.discussion_id
      })
      .then(() => this.loading = false)
  }
};
</script>

<style lang="scss" scoped>

h4, h5 {
  color: #505050;
  font-weight: 400;
}

.description {
  border-radius: 15px;
  min-height: 200px;
  background-color: #fdfbfb;
  padding: 10px;
}

.white-page {
  padding: 20px;
  width: 80%;
  margin: 0 auto;
}

.video-fluid {
  width: 100%;
  height: auto;
}

.video-thumb {
  width: 80%;
  height: auto;

  &.activeVid img {
    border: 2px #009894 solid;
  }
}
</style>
